// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "resendTicketsForm__input-1H6BX";
var _3 = "resendTicketsForm__inputUnderline-11f0E";
export { _1 as "__esModule", _2 as "resendTicketsForm__input", _3 as "resendTicketsForm__inputUnderline" }
export default { "__esModule": _1, "resendTicketsForm__input": _2, "resendTicketsForm__inputUnderline": _3 }
